import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneairportcabs() {



const cardData = {
  keyword: "Pune Airport Cabs",
  heading: "Lotus Cab: Pune Airport Cabs",

  headingDescription:
    "Lotus Cab provides reliable and punctual Pune Airport Cabs for smooth airport pickup and drop services. Whether you need a late-night airport transfer, early morning drop, corporate travel, family pickup, or outstation connection from Pune Airport, our well-maintained AC sedan and SUV fleet ensures comfort and safety. Our professional chauffeurs track flight timings to avoid delays and ensure timely arrival. We offer transparent pricing with no hidden charges and flexible booking options. With 24/7 customer support and doorstep pickup anywhere in Pune, we make airport travel convenient, affordable, and completely stress-free.",

  top: "Top Places to Visit in Pune After Airport Pickup with Lotus Cab",

  topPlaces: [
    {
      title: "Shaniwar Wada",
      description:
        "Shaniwar Wada is one of Pune’s most iconic historical landmarks. Built in 1732, it represents the glorious Maratha history. Visitors explore the grand gates and heritage ruins. The evening light and sound show is popular. Ideal for history lovers and tourists. A perfect sightseeing stop after airport pickup."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is a symbol of India’s freedom movement. It is associated with Mahatma Gandhi’s history. The palace features beautiful architecture and peaceful gardens. Popular among cultural travelers. Ideal for photography and reflection. A meaningful destination after airport transfer."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Sinhagad Fort is a historic hill fort near Pune. It offers panoramic valley views and trekking opportunities. Popular among adventure seekers. Ideal for sunrise visits. Rich in Maratha history. A scenic getaway after airport arrival."
    },
    {
      title: "Dagdusheth Halwai Ganpati Temple",
      description:
        "This temple is one of Pune’s most famous spiritual sites. Dedicated to Lord Ganesha, it attracts thousands of devotees. The idol is beautifully decorated. Ideal for religious visits. Located centrally in Pune. A peaceful stop after airport drop."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "Khadakwasla Dam offers scenic lake views and fresh air. Popular for sunset photography and family outings. Located a short drive from Pune city. Ideal for relaxing after travel. Surrounded by greenery. A refreshing attraction near Pune."
    },
    {
      title: "Osho International Meditation Resort",
      description:
        "Located in Koregaon Park, this meditation resort attracts global visitors. It offers peaceful surroundings and wellness sessions. Ideal for relaxation and mindfulness. Popular among international travelers. A unique experience after airport arrival."
    },
    {
      title: "Parvati Hill",
      description:
        "Parvati Hill offers panoramic city views. The temple complex at the top is spiritually significant. Ideal for short treks and sightseeing. Popular during sunrise and sunset. A historic landmark in Pune. Great stop after airport transfer."
    },
    {
      title: "Phoenix Marketcity Mall",
      description:
        "Phoenix Marketcity is a major shopping and entertainment hub. It offers branded stores, restaurants, and cinemas. Ideal for shopping lovers. Air-conditioned comfort makes it convenient. Popular among visitors. A great place after airport pickup."
    }
  ],

  services: [
    {
      name: "Pune Airport Taxi Service",
      description:
        "Reliable airport taxi service for pickup and drop at Pune Airport. Professional chauffeurs track flight timings. AC sedan and SUV options available. Transparent pricing policy maintained. Suitable for business and family travel. 24/7 booking support provided."
    },
    {
      name: "Pune Airport Pickup and Drop",
      description:
        "Convenient pickup and drop service for domestic and international flights. Timely arrival ensured. Clean and sanitized vehicles available. Ideal for corporate and personal travel. Transparent fare breakdown provided. Smooth airport transfer guaranteed."
    },
    {
      name: "24/7 Pune Airport Taxi",
      description:
        "Round-the-clock airport taxi service for late-night and early-morning flights. Safe and secure travel ensured. Professional drivers available. Flexible booking supported. Transparent billing maintained. Reliable airport connectivity guaranteed."
    },
    {
      name: "Affordable Pune Airport Cab",
      description:
        "Budget-friendly airport cab service without compromising comfort. Competitive pricing available. Clean AC vehicles ensured. Suitable for daily travel needs. Transparent fare policy maintained. Comfortable ride guaranteed."
    },
    {
      name: "Luxury Airport Cab Pune",
      description:
        "Premium luxury airport transfer service for executive and VIP travel. High-end vehicles available. Superior comfort ensured. Professional chauffeurs provided. Ideal for corporate clients. Premium airport experience guaranteed."
    },
    {
      name: "SUV Taxi Pune Airport",
      description:
        "Spacious SUV taxis for group and family airport travel. Extra luggage space available. Comfortable seating ensured. Ideal for family pickup and drop. Smooth ride performance guaranteed. Safe and dependable service."
    },
    {
      name: "Corporate Airport Cab Pune",
      description:
        "Professional corporate airport transfer service. Ideal for business meetings and executive travel. Punctual pickup ensured. Transparent billing structure maintained. Clean and well-maintained vehicles provided. Reliable corporate travel solution."
    },
    {
      name: "Online Airport Cab Booking Pune",
      description:
        "Easy online booking with instant confirmation. Secure payment options available. Flexible pickup scheduling supported. Transparent pricing shared before confirmation. 24/7 customer support provided. Hassle-free booking process."
    }
  ],

  tableData: [
    ["Pune Airport Cabs", "Pune Airport Taxi Service"],
    ["Pune Airport Pickup and Drop", "Pune Airport Cab Booking"],
    ["24/7 Pune Airport Taxi", "Affordable Pune Airport Cab"],
    ["Luxury Airport Cab Pune", "SUV Taxi Pune Airport"],
    ["Sedan Airport Taxi Pune", "Pune Airport Transfer Service"],
    ["Corporate Airport Cab Pune", "Family Pickup Pune Airport"],
    ["Online Airport Cab Booking Pune", "Pune Airport Drop Taxi"],
    ["Pune Airport to City Cab", "Pune Airport Outstation Taxi"],
    ["AC Airport Cab Pune", "Best Airport Taxi Service Pune"],
    ["Pune Airport Chauffeur Service", "Instant Airport Cab Pune"]
  ],

  whychoose: [
    {
      WhyChooseheading: "On-Time Airport Transfers",
      WhyChoosedescription:
        "Flight tracking and punctual service ensure timely pickup and drop at Pune Airport."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription:
        "Clear fare structure with no hidden airport charges."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription:
        "Round-the-clock service for early morning and late-night flights."
    },
    {
      WhyChooseheading: "Professional Chauffeurs",
      WhyChoosedescription:
        "Trained drivers ensure safe and smooth airport travel."
    },
    {
      WhyChooseheading: "Well-Maintained AC Vehicles",
      WhyChoosedescription:
        "Clean and sanitized sedan and SUV fleet for comfortable travel."
    },
    {
      WhyChooseheading: "Corporate Travel Friendly",
      WhyChoosedescription:
        "Ideal for business and executive airport transfers."
    },
    {
      WhyChooseheading: "Family & Group Comfort",
      WhyChoosedescription:
        "Spacious SUV options for luggage and family travel."
    },
    {
      WhyChooseheading: "Instant Booking Support",
      WhyChoosedescription:
        "Quick online booking with instant confirmation and 24/7 support."
    }
  ]
};

const faqData = [
  { question: "Do you provide 24/7 airport taxi?", answer: "Yes, airport cab service is available 24/7 including night travel." },
  { question: "Is flight tracking included?", answer: "Yes, drivers monitor flight timings to ensure timely pickup." },
  { question: "Are toll charges included?", answer: "Toll and parking charges are informed before booking confirmation." },
  { question: "Can I book SUV for airport travel?", answer: "Yes, SUV taxis are available for family and group travel." },
  { question: "Is online booking available?", answer: "Yes, instant online booking is available." },
  { question: "Do you provide corporate airport transfers?", answer: "Yes, corporate airport cab service is available." },
  { question: "Are vehicles sanitized?", answer: "Yes, vehicles are cleaned and sanitized before every trip." },
  { question: "Can I schedule early morning pickup?", answer: "Yes, early morning airport drop is available." },
  { question: "Do you provide outstation transfer from airport?", answer: "Yes, direct outstation transfer service is available from Pune Airport." },
  { question: "Is chauffeur service available?", answer: "Yes, professional chauffeur service is provided for premium travel." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akshay Patil",
    feedback:
      "Booked early morning airport drop and the driver arrived before time. Very professional and smooth service. Highly reliable airport cab.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "Family pickup from Pune Airport was comfortable. Spacious SUV and polite driver made it stress-free. Transparent pricing impressed us.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Rahul Deshmukh",
    feedback:
      "Corporate airport transfer was perfectly managed. Clean vehicle and punctual service. Will book again.",
    rating: 5
  }
];
































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Airport Cabs",
  "image": "https://lotuscab.com/assets/images/pune-airport-cabs.jpg", 
  "description": "Lotus Cab offers reliable Pune Airport cabs including pickup, drop, and transfer services. Book affordable, luxury, sedan, and SUV taxis for family, corporate, and outstation travel with 24/7 online booking and professional drivers for safe and comfortable airport transfers.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-airport-cabs"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pune Airport Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune Airport cabs with Lotus Cab. Affordable 24/7 pickup, drop & transfer services with sedan, SUV & luxury taxis for family & corporate travel. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune Airport Cabs, Pune Airport Taxi Service, Pune Airport Pickup and Drop, Pune Airport Cab Booking, 24/7 Pune Airport Taxi, Affordable Pune Airport Cab, Luxury Airport Cab Pune, SUV Taxi Pune Airport, Sedan Airport Taxi Pune, Pune Airport Transfer Service, Corporate Airport Cab Pune, Family Pickup Pune Airport, Online Airport Cab Booking Pune, Pune Airport Drop Taxi, Pune Airport to City Cab, Pune Airport Outstation Taxi, AC Airport Cab Pune, Best Airport Taxi Service Pune, Pune Airport Chauffeur Service, Instant Airport Cab Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneairportcabs;